import {TimeAgoPipe} from "time-ago-pipe";
import {NgModule} from "@angular/core";

@NgModule({
  imports: [],
  declarations: [TimeAgoPipe],
  exports: [TimeAgoPipe]
})
export class TimeAgoModule { }
